import { Injectable, ErrorHandler, inject } from '@angular/core'
import { errorDetails, LoggerService } from '@agroone-front/shared'

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  private logger = inject(LoggerService)

  override handleError(error: unknown) {
    super.handleError(error)
    // The logger prints the message in a template string: an absent message reads "undefined", as before
    this.logger.error(String(errorDetails(error).message), error)
  }
}
